import React, { useState } from "react";
import axios from "../../api/axios";
import { DASHBOARD_URL } from "../../lib/dashboardUrl";
import ConfirmationModal from "../../components/ConfirmationModal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SupportLogin = () => {
  const [pin, setPin] = useState("");
  const [message, setMessage] = useState("");
  const [userData, setUserData] = useState(null);
  const [token, setToken] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post("/api/admin/user/support-login", { pin });
      setMessage("Login successful!");
      toast.success("Login successful!");
      setUserData(response.data.data);
      setToken(response.data.token);
      console.log("API Response:", response.data);

      const { username, name, email, role } = response.data.data;
      const newToken = response.data.token;
      const baseUrl = `${DASHBOARD_URL}/support-signin`;
      const url = `${baseUrl}?username=${username}&name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}&role=${role}&token=${newToken}`;
      setRedirectUrl(url);
      setIsModalOpen(true);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setMessage(`Login failed: ${error.response.data.message}`);
        toast.error(`Login failed: ${error.response.data.message}`);
      } else {
        setMessage("Login failed. Please check your pin.");
        toast.error("Login failed. Please check your pin.");
      }
      setUserData(null);
      setToken("");
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
      setPin("");
    }
  };

  const handleConfirmRedirect = () => {
    setIsModalOpen(false);
    if (redirectUrl) {
      window.open(redirectUrl, "_blank");
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="p-4">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Support
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground">
        Support <span className="text-gradient-ginox">Login</span>
      </h1>
      <p className="text-sm text-muted-foreground mb-6">
        Access user account by entering Support PIN below.
      </p>

      <div className="border-t border-white/[0.08] pt-5 max-w-md">
        <div className="mb-4">
          <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
            Support PIN
          </label>
          <input
            type="text"
            placeholder="Enter the PIN"
            className="w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
          />
        </div>
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50"
        >
          {isLoading ? "Logging in..." : "Login"}
        </button>
      </div>

      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmRedirect}
        title="Redirect to Support Page"
        message="Login successful! Do you want to proceed to the support page?"
        confirmText="Yes, Redirect"
        cancelText="No, Stay Here"
      />
    </div>
  );
};

export default SupportLogin;
